import { render, staticRenderFns } from "./AzComboEnumLicitacao.vue?vue&type=template&id=6f140eaa"
import script from "./AzComboEnumLicitacao.vue?vue&type=script&lang=js"
export * from "./AzComboEnumLicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports